import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'
import { useProjectStore } from '@/stores/project';
import { useIdentityStore } from '@/stores/identity';

export async function buildGoLive() {
  


  const identity = useIdentityStore();
  const project = useProjectStore();

    //Only show the card to admins as this is an internal task
    if(identity.type !== 'Administrator') return null;

    var milestones = project.milestones;    

    // Check if the trigger milestone (Payroll Handover) is completed before showing the Go Live card
    const triggerMilestone = milestones.find(m => m.type === 'PayrollHandover');
    if(triggerMilestone == null || triggerMilestone.status !== 'SuccessfullyCompleted') {
      return null;
    }

    const milestone = milestones.find(m => m.type === 'GoLive');
    if(milestone == null) {
      return null;
    }

    const card = {
    id: milestone.milestoneId,
    title: 'Go Live',
    subtitle: 'Ensure all systems are ready for the customer go-live.',
    progress: 0,
    subProgressMessage: formatDateToWrittenDate(milestone.scheduledCompletion),
    status: milestone.status,
    route: '/tasks/internal-milestone/' + milestone.milestoneId, 
    createdDate: new Date(milestone.scheduledCompletion)
  }

  return card 
}

